const ADYENCC = {};
const isEditPaymentPage = window.location.href.includes('editpayment');

ADYENCC.init = function () {
  if (isEditPaymentPage) {
    initializeZppAdyenForm();
  }
};

const initializeZppAdyenForm = () => {
  if (window.Payment && window.Payment.renderAdyenManageCreditCards) {
    window.Payment.renderAdyenManageCreditCards();
  }
};

export default ADYENCC;
